module.exports = "<div class=\"ui padded grid\">\n  <div class=\"sixteen wide column\">\n    <div class=\"ui three doubling stackable cards\">\n      <list-item v-for=\"dataset in datasets\" v-bind:item=\"dataset\"></list-item>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/components/application-area/datasets/template.html
// module id = 80
// module chunks = 0